import GATSBY_COMPILED_MDX from "/home/yuya/gatsbyjs/InvestmentTechHack/src/posts/mesure-the-risk/risk-of-ruin.md";
import React from "react";
import {graphql} from "gatsby";
import {MDXProvider} from "@mdx-js/react";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import Layout from '../components/ui/layout';
import Seo from '../components/ui/seo';
import Share from '../components/ui/share';
import Tags from '../components/post/tags';
import Breadcrumb from '../components/post/breadcrumb';
import Auther from '../components/post/auther';
import Toc from '../components/post/toc';
import {H2, H3, H4, H5, H6, P, A, Em, Strong, Break, Blockquote, Cite, List, OrderedList, ListItem, Table, Td, Th, Tr, Contaner, Note, Small, LinkList, Button, ButtonLink, LinkComponent, LinkToAnchorComponent, TweetComponent, YouTubeComponent, Video, Iframe} from '../components/post/mdx';
import RichLink from '../components/post/rich-link';
import {SliderMdx} from '../components/util/slider';
import ModalOpt04 from '../components/modal/opt-form-04';
import ModalOpt05 from '../components/modal/opt-form-05';
import ModalOpt06 from '../components/modal/opt-form-06';
import "../styles/post.css";
import 'katex/dist/katex.min.css';
const components = {
  ModalOpt04,
  ModalOpt05,
  ModalOpt06,
  Contaner,
  Note,
  Small,
  LinkList,
  Cite,
  Tweet: TweetComponent,
  YouTube: YouTubeComponent,
  Youtube: YouTubeComponent,
  Link: LinkComponent,
  RichLink,
  LinkToAnchor: LinkToAnchorComponent,
  Video,
  Button,
  ButtonLink,
  Slider: SliderMdx,
  h1: H2,
  h2: H3,
  h3: H4,
  h4: H5,
  h5: H6,
  h6: H6,
  p: P,
  a: A,
  em: Em,
  strong: Strong,
  hr: Break,
  ul: List,
  ol: OrderedList,
  li: ListItem,
  blockquote: Blockquote,
  table: Table,
  td: Td,
  th: Th,
  tr: Tr,
  iframe: Iframe
};
const PostTemplate = ({data, location, children}) => {
  const title = data.mdx.frontmatter.title;
  const topUrl = data.site.siteMetadata.siteUrl;
  const url = `${topUrl}${location.pathname}`;
  const twitterid = data.site.siteMetadata.twitterid;
  const items = data.mdx.tableOfContents.items;
  const slug = data.mdx.internal.contentFilePath.match(/(?<=\/posts\/).*(?=\.(md|mdx))/g)[0];
  let catSlug;
  let category;
  data.site.siteMetadata.categories.forEach(catMeta => {
    if (~slug.indexOf(`${catMeta.slug}/`)) {
      catSlug = catMeta.slug;
      category = catMeta.label;
      return;
    }
  });
  const dateModified = new Date(data.mdx2.frontmatter.dateModified);
  const dateNow = new Date();
  const yearsFromModified = Math.ceil((dateNow.getTime() - dateModified.getTime()) / (1000 * 60 * 60 * 24 * 365));
  return React.createElement(Layout, null, React.createElement("header", {
    className: "max-w-screen-sm px-8 md:px-0 mx-auto"
  }, React.createElement("h1", {
    className: "pt-28 text-3xl font-bold text-center leading-snug"
  }, title), React.createElement("div", {
    className: "mt-5 text-xs text-gray-600 text-center"
  }, React.createElement(Breadcrumb, {
    catLabel: category,
    catSlug: catSlug
  }), React.createElement(Tags, {
    tags: data.mdx.frontmatter.tags,
    tagsMeta: data.site.siteMetadata.tags
  })), React.createElement("div", {
    className: "mt-2 text-xs text-gray-600 text-center italic"
  }, React.createElement("span", {
    className: "inline-block px-2"
  }, "Posted on ", data.mdx.frontmatter.datePublished), React.createElement("span", {
    className: "inline-block px-2"
  }, "Updated on ", data.mdx.frontmatter.dateModified)), React.createElement("div", {
    className: "pt-24 px-0 md:px-8 mx-auto max-w-screen-sm"
  }, data.mdx.frontmatter.eyecatch && React.createElement(GatsbyImage, {
    className: "w-full rounded-lg overflow-hidden shadow-xl",
    image: getImage(data.mdx.frontmatter.eyecatch),
    alt: title
  }), yearsFromModified >= 3 && React.createElement("div", {
    className: "my-5 py-1 px-6 bg-gray-400 bg-opacity-10 rounded-lg overflow-auto"
  }, React.createElement("p", {
    className: "my-4 text-sm leading-relaxed"
  }, "※ この記事は最終更新日から", yearsFromModified, "年以上が経過しています。")))), React.createElement("article", {
    "data-clarity-region": "article",
    className: "mt-6 grid grid-cols-1 md:grid-cols-4 xl:grid-cols-5 gap-x-8 gap-y-0 md:mx-auto"
  }, React.createElement("div", {
    className: `w-full max-w-xl mx-auto px-4 col-span1 md:row-start-1 ${items ? "md:col-span-3" : "md:col-span-4 xl:col-span-3"} xl:col-start-2 overflow-auto`
  }, React.createElement(MDXProvider, {
    components: components
  }, children), data.mdx.frontmatter.tags.length > 0 && React.createElement("div", {
    className: "mt-36 -mb-24 text-sm text-gray-600 text-center"
  }, React.createElement("span", {
    className: "inline-block mr-6"
  }, "同じタグの記事"), React.createElement(Tags, {
    tags: data.mdx.frontmatter.tags,
    tagsMeta: data.site.siteMetadata.tags
  })), React.createElement(Auther), React.createElement("div", {
    className: "mt-12 mb-1 text-sm text-center"
  }, React.createElement(LinkComponent, {
    to: "/lp/learn-by-email"
  }, "20日間のメールで、資金管理をゼロからはじめる"))), items ? React.createElement("div", {
    className: "w-full max-w-xl mt-0 md:mt-48 mx-auto pl-4 row-start-1 md:col-span-1"
  }, React.createElement(Toc, {
    items: items
  })) : null, React.createElement("div", {
    className: "mt-36 md:mt-48 col-span-1 md:col-span-4 xl:col-span-1 xl:col-start-1 xl:row-start-1"
  }, React.createElement("div", {
    className: "static md:sticky top-0 pt-0 xl:pt-5"
  }, React.createElement(Share, {
    message: "記事をシェア",
    title: title,
    url: url,
    twitterid: twitterid
  })))));
};
PostTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(PostTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = ({data, location}) => {
  const title = data.mdx.frontmatter.title;
  const topUrl = data.site.siteMetadata.siteUrl;
  const url = `${topUrl}${location.pathname}`;
  const slug = data.mdx.internal.contentFilePath.match(/(?<=\/posts\/).*(?=\.(md|mdx))/g)[0];
  const eyecatch = data.mdx.frontmatter.eyecatch ? {
    src: data.mdx.frontmatter.eyecatch.childImageSharp.original.src,
    width: data.mdx.frontmatter.eyecatch.childImageSharp.original.width,
    height: data.mdx.frontmatter.eyecatch.childImageSharp.original.height
  } : {};
  let catSlug;
  let category;
  data.site.siteMetadata.categories.forEach(catMeta => {
    if (~slug.indexOf(`${catMeta.slug}/`)) {
      catSlug = catMeta.slug;
      category = catMeta.label;
      return;
    }
  });
  return React.createElement(Seo, {
    pageTitle: title,
    pageDescription: data.mdx.frontmatter.description,
    pageUrl: location.pathname,
    pageImageUrl: eyecatch && eyecatch.src,
    pageImageWidth: eyecatch && eyecatch.width,
    pageImageHeight: eyecatch && eyecatch.height,
    pageDatePublished: data.mdx2.frontmatter.datePublished,
    pageDateModified: data.mdx2.frontmatter.dateModified,
    isArticleLdJSON: true,
    breadcrumbList: [{
      position: 1,
      url: `${topUrl}/${catSlug}/`,
      name: category
    }, {
      position: 2,
      url: url,
      name: title
    }]
  });
};
export const pageQuery = graphql`
  query ($id: String) {
    mdx(id: { eq: $id }) {
      id
      internal {
        contentFilePath
      }
      tableOfContents(maxDepth: 2)
      frontmatter {
        title
        datePublished(formatString: "MMMM Do, YYYY")
        dateModified(formatString: "MMMM Do, YYYY")
        draft
        tags
        description
        eyecatch {
          childImageSharp {
            gatsbyImageData(
              placeholder: DOMINANT_COLOR
              width: 580
            )
            original {
              height
              width
              src
            }
          }
        }
      }
    }
    mdx2 : mdx(id: { eq: $id }) {
      frontmatter {
        datePublished(formatString: "yyyy-MM-DD")
        dateModified(formatString: "yyyy-MM-DD")
      }
    }
    site {
      siteMetadata {
        title
        siteUrl
        twitterId
        tags {
          label
          slug
        }
        categories {
          label
          slug
        }
      }
    }
  }
`;
